export default __webpack_public_path__ + "static/media/rndpage1-2.bd17680c.png";